import {ControlledInput, LabelRegular} from '@hm/fundamental'
import {Controller, useFormContext} from 'react-hook-form'

import {InputSkeleton} from '../../../common/skeletons/InputSkeleton'
import {useTranslation} from '../../../hooks/useTranslation'
import {CompanyFormData} from '../CompanyForm.types'

export interface WebhookNotificationEmailsInputProps {
  readonlyMode: boolean
  isLoading: boolean
  testIdPrefix: string
}

export const WebhookNotificationEmailsInput = ({
  readonlyMode,
  isLoading,
  testIdPrefix
}: WebhookNotificationEmailsInputProps) => {
  const {t} = useTranslation()
  const {control, formState} = useFormContext<CompanyFormData>()
  const errors = formState.errors
  const name = 'webhookNotificationEmails'

  if (isLoading) {
    return <InputSkeleton />
  }

  const hasError = !!errors[name]?.message
  const localKey = `errorMessages.${errors[name]?.message}`
  const errorText = hasError ? t(localKey) : ''

  return (
    <Controller
      name={name}
      control={control}
      render={({field, fieldState}) => {
        // Convert array to comma-separated string for display
        const displayValue =
          readonlyMode && (!field.value || field.value.length === 0)
            ? '-'
            : Array.isArray(field.value)
              ? field.value.join(', ')
              : field.value || ''

        return (
          <div>
            <ControlledInput
              value={displayValue}
              onFocus={() => {
                // Convert array to string when starting to edit
                if (Array.isArray(field.value)) {
                  field.onChange(field.value.join(', '))
                }
              }}
              onChange={(e) => {
                // Store the raw string value during typing
                field.onChange(e.target.value)
              }}
              onBlur={(e) => {
                // Convert comma-separated string to array only on blur
                const emails = e.target.value
                  .split(',')
                  .map((email) => email.trim())
                  .filter((email) => email.length > 0)
                field.onChange(emails.length > 0 ? emails : [])
                field.onBlur()
              }}
              data-test-id={`${testIdPrefix}-${name}`}
              label={t('companyForm.webhookNotificationEmails')}
              isReadOnly={readonlyMode}
              error={errorText}
              isTouched={fieldState.isTouched}
            />
            {!readonlyMode && (
              <LabelRegular className="text-foreground_faded mt-1 px-2">
                {t('companyForm.webhookNotificationEmailsHelper')}
              </LabelRegular>
            )}
          </div>
        )
      }}
    />
  )
}
